import { AsyncPipe, NgClass, NgIf } from '@angular/common';
import { AfterViewInit, Component, Inject, ViewChild } from '@angular/core';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyButtonModule } from '@angular/material/legacy-button';
import { MAT_LEGACY_DIALOG_DATA, MatLegacyDialogModule, MatLegacyDialogRef } from '@angular/material/legacy-dialog';
import { MatStep, MatStepper, MatStepperModule } from '@angular/material/stepper';
import _ from 'lodash';
import { Countertop } from '../../../models/cutting/countertop';
import { CuttingButt } from '../../../models/cutting/cutting-butt.model';
import { CuttingButtFormService } from '../../../services/cutting-butt-form.service';
import { CountertopSchemaComponent } from '../../countertop-schema/countertop-schema.component';
import { EdgesInColorComponent } from '../../edge-in-color/edges-in-color.component';
import { MaterialBaseButtsComponent } from '../../material-base-butts';

export type EdgeBandingWizardDialogResult = { banding: CuttingButt; sideNumbers: number[] };

export interface EdgeBandingWizardDialogData {
  countertop: Countertop;
  showQuantityInStock: boolean;
  countertopThickness: number;
  materialInMatBaseId: number;
}

@Component({
  templateUrl: 'edge-banding-wizard-dialog.component.html',
  standalone: true,
  imports: [
    MatLegacyDialogModule,
    MatIconModule,
    MatDividerModule,
    MatLegacyButtonModule,
    MatStepperModule,
    MatLegacyDialogModule,
    CountertopSchemaComponent,
    MaterialBaseButtsComponent,
    NgIf,
    NgClass,
    AsyncPipe,
    EdgesInColorComponent,
  ],
  providers: [CuttingButtFormService],
  styles: [
    `
      :host ::ng-deep .mat-horizontal-content-container {
        display: none;
      }
    `,
  ],
})
export class EdgeBandingWizardDialogComponent implements AfterViewInit {
  selectedBanding: CuttingButt;
  sideNumbers: Set<number> = new Set();

  hasMatchedButts = false;

  @ViewChild(CountertopSchemaComponent, { static: true }) schema: CountertopSchemaComponent;
  @ViewChild(MatStepper, { static: true }) stepper: MatStepper;
  @ViewChild('sideSelectStep', { static: true }) sideSelectStep: MatStep;

  constructor(
    public dialogRef: MatLegacyDialogRef<EdgeBandingWizardDialogComponent>,
    private cuttingButtFormService: CuttingButtFormService,
    @Inject(MAT_LEGACY_DIALOG_DATA) public data: EdgeBandingWizardDialogData
  ) {}

  ngAfterViewInit(): void {
    this.render();

    this.cuttingButtFormService
      .getMatchedButtsForClient(this.data.materialInMatBaseId, this.data.countertopThickness)
      .then(v => {
        this.hasMatchedButts = !!v.length;
      });
  }

  render(): void {
    this.schema?.render(this.data.countertop, 'schema', {
      highlightedSides: _.fromPairs(Array.from(this.sideNumbers).map(key => [key, 'red'])),
      sideSelectors: true,
      disabledSideSelectors: Object.keys(this.data.countertop.outline.edgeBanding).filter(sn =>
        this.data.countertop.checkSidePostforming(sn)
      ),
    });
  }

  sideSelected(sideNumber: number): void {
    this.sideNumbers.has(+sideNumber) ? this.sideNumbers.delete(+sideNumber) : this.sideNumbers.add(+sideNumber);

    this.render();
  }

  goToEdgeBandingSelect(): void {
    this.sideSelectStep.completed = true;
    this.stepper.next();
  }

  saveAndClose(): void {
    this.dialogRef.close({
      banding: this.selectedBanding,
      sideNumbers: Array.from(this.sideNumbers),
    } as EdgeBandingWizardDialogResult);
  }
}
